import React, { useContext } from 'react';
import { Button } from '../ui/Button';
import { NavigationContext, CartContext } from '../../App';
export interface Product {
  id: number;
  name: string;
  price: string;
  category: string;
  color: string;
  image?: string;
  badge?: 'New' | 'Sale';
}
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  const {
    navigate
  } = useContext(NavigationContext);
  const {
    addToCart
  } = useContext(CartContext);
  const handleProductClick = () => {
    navigate('product');
  };
  const handleAddToCart = () => {
    const priceNum = parseFloat(product.price.replace('$', ''));
    addToCart({
      id: product.id,
      name: product.name,
      price: priceNum,
      size: 'M',
      color: 'Default',
      quantity: 1,
      image: product.image || product.color
    });
  };
  return <div className="group" data-id="element-469">
      {/* Product Image - Reduced from aspect-[3/4] to aspect-[4/5] */}
      <div onClick={handleProductClick} className={`relative w-full aspect-[4/5] ${!product.image ? product.color : 'bg-[#F5E6D3]'} mb-5 overflow-hidden cursor-pointer`} data-id="element-470">
        {product.image ? <img src={product.image} alt={product.name} className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105" data-id="element-471" /> : <div className="w-full h-full flex items-center justify-center text-[#6B5B4F]/40 font-['Playfair_Display'] italic text-xl" data-id="element-472">
            Coming Soon
          </div>}

        {/* Badge */}
        {product.badge && <div className="absolute top-3 left-3 z-10" data-id="element-473">
            <span className={`inline-block px-3 py-1.5 text-sm font-semibold tracking-wider uppercase ${product.badge === 'Sale' ? 'bg-[#C65D3B] text-white' : 'bg-[#D4A853] text-[#1A1A1A]'}`} data-id="element-474">
              {product.badge}
            </span>
          </div>}

        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" data-id="element-475" />

        {/* Quick Add Button */}
        {product.image && <div className="absolute bottom-0 left-0 w-full p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" onClick={e => e.stopPropagation()} data-id="element-476">
            <Button className="w-full bg-[#5C3D2E] text-white hover:bg-[#D4A853] hover:text-[#1A1A1A] text-base" size="sm" onClick={handleAddToCart} data-id="element-477">
              Add to Cart
            </Button>
          </div>}

        {/* Decorative corner */}
        <div className="absolute top-3 right-3 w-8 h-8 border-t border-r border-[#D4A853]/50 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-478" />
      </div>

      {/* Product Info - Increased font sizes */}
      <div className="space-y-2" data-id="element-479">
        <h3 onClick={handleProductClick} className="text-xl sm:text-2xl font-['Playfair_Display'] text-[#5C3D2E] group-hover:text-[#D4A853] transition-colors cursor-pointer leading-snug" data-id="element-480">
          {product.name}
        </h3>
        <p className="text-xl text-[#6B5B4F] font-['Raleway'] font-medium" data-id="element-481">
          {product.price}
        </p>
      </div>
    </div>;
}